export default function partnersSliderController() {
  const swiperElement = document.querySelector('.partners-slider .swiper');

  if (!swiperElement) {
    return;
  }

  whenInViewport(swiperElement, () => {
    const slidesPerView = parseInt(swiperElement.dataset.sliderPerView, 10) || 6;
    const autoplayEnabled = swiperElement.dataset.sliderAutoplay === 'true';
    const autoplayDelay = parseInt(swiperElement.dataset.sliderAutoplayDelay, 10) || 3000;
    const autoplayMode = swiperElement.dataset.sliderAutoplayMode || 'autoplay';
    const showPagination = swiperElement.dataset.sliderShowPagination === 'true';
    const swiperSpeed = parseInt(swiperElement.dataset.sliderSwiperSpeed, 10) || 500;

    const swiperPagination = document.createElement('div');
    swiperPagination.classList.add('swiper-pagination');
    if (showPagination) {
      swiperElement.appendChild(swiperPagination);
    }

    if (true) {
      fillSwiperToFullWidth(swiperElement);
    }

    let additionalSettings = {};

    if (autoplayMode === 'autoscroll') {
      additionalSettings = {
        ...additionalSettings,
        autoplay: {
          disableOnInteraction: false,
          delay: 0, //autoplayDelay,
        },
        freeMode: true,
      };
    }

    const slides = swiperElement.querySelectorAll('.swiper-slide');

    const swiper = new Swiper(swiperElement, {
      init: false,
      slidesPerView: 3,
      spaceBetween: 32,
      loop: true,
      simulateTouch: true,
      touchStartPreventDefault: false,
      speed: swiperSpeed,
      // centeredSlides: true,
      // initialSlide: Math.floor(slides / 2),
      // slidesPerView: 'auto',
      // slidesPerView: 3,

      autoplay: autoplayEnabled
        ? {
            disableOnInteraction: false,
            delay: autoplayDelay,
          }
        : false,

      pagination: showPagination
        ? {
            el: swiperPagination,
            clickable: true,
          }
        : false,

      ...additionalSettings,

      breakpoints: {
        761: {
          slidesPerView: Math.max(3, Math.round(slidesPerView / 1.5)),
        },
        991: {
          slidesPerView: Math.max(6, slidesPerView),
        },
      },
    });

    swiper.init();
    swiper.slideTo(Math.floor(slides.length / 2), 0, false);
  });
}
